// enrich-profile.component.ts
import { Component, Input, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Observable, Subject, take } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { Actions, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { AsyncPipe, CommonModule } from "@angular/common";
import { trigger, state, style, transition, animate } from '@angular/animations';
import {
  enrichProfile,
  enrichProfileSuccess,
  updateReportEnrichStatus,
  updateReportStatusInStore,
  updateReport
} from '../../../state/search/search.actions';
import {
  selectEnrichmentLoading,
  selectEnrichmentData,
  selectEnrichmentError,
  selectReportEnrichStatus
} from '../../../state/search/search.selectors';
@Component({
  selector: 'app-enrich-profile',
  standalone: true,
  imports: [
    AsyncPipe,
    CommonModule
  ],
  templateUrl: './enrich-profile.component.html',
  styleUrl: './enrich-profile.component.scss',
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms 300ms ease-out', style({ opacity: 1 }))
      ])
    ])
  ]
})
export class EnrichProfileComponent implements OnInit, OnDestroy {

  @Input() reportSearch: any;
  @Output() profileEnriched = new EventEmitter<void>();
  @Input() aside: boolean;

  enrichmentLoading$: Observable<boolean>;
  enrichmentData$: Observable<any>;
  enrichmentError$: Observable<any>;
  
  isButtonHovered = false;

  private destroy$ = new Subject<void>();

  constructor(private store: Store, private actions$: Actions) {
    this.enrichmentLoading$ = this.store.select(selectEnrichmentLoading);
    this.enrichmentData$ = this.store.select(selectEnrichmentData);
    this.enrichmentError$ = this.store.select(selectEnrichmentError);

    // Debug: log enrich status changes
    /*
    this.store.select(selectReportEnrichStatus).pipe(
      takeUntil(this.destroy$)
    ).subscribe(status => {
      console.log('Enrich status changed to:', status);
    });
    */
  }

  ngOnInit(): void {
    // console.log('[enrich-profile.component.ts] ngOnInit')
    // console.log('[enrich-profile.component.ts] reportSearch', this.reportSearch)
  }

  enhanceProfile() {
    // console.log('[enrich-profile.component.ts] enhanceProfile')

    const element = document.getElementById('personInsights');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    if (this.reportSearch && this.reportSearch.id) {
      // Dispatch the enrich profile action
      this.store.dispatch(enrichProfile({ searchId: this.reportSearch.id }));

      // Listen for success
      this.actions$.pipe(
        ofType(enrichProfileSuccess),
        take(1),
        takeUntil(this.destroy$)
      ).subscribe(() => {
        // Emit event to parent component
        this.profileEnriched.emit();

        // The report update is now handled by the effect
      });
    } else {
      console.error('No search ID available');
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
